
riot.tag2('companies-list', '  <catalog search="true" sortable="true" object="Company" cols="{cols}" allselect="true" reload="true" add="{permission(add, &quot;contacts&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;contacts&quot;, &quot;0001&quot;)}" dblclick="{permission(companyOpen, &quot;contacts&quot;, &quot;1000&quot;)}" store="persons-list">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="name">{row.name}</datatable-cell>\n      <datatable-cell name="inn">{row.inn}</datatable-cell>\n      <datatable-cell name="kpp">{row.kpp}</datatable-cell>\n      <datatable-cell name="email">{row.email}</datatable-cell>\n      <datatable-cell name="phone">{row.phone}</datatable-cell>\n      <datatable-cell name="note">{row.note}</datatable-cell>\n    </yield>\n    <yield to="filters">\n      <div class="well well-sm">\n        <div class="form-inline">\n          <div class="form-group">\n            <label class="control-label">Группа</label>\n            <select class="form-control" data-name="idGroup" data-sign="IN">\n              <option value="">Все</option>\n              <option each="{category, i in parent.categories}" value="{category.id}" no-reorder>{category.name}</option>\n            </select>\n          </div>\n        </div>\n      </div>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');
self.collection = 'Company';

self.cols = [{ name: 'id', value: '#' }, { name: 'name', value: 'Наименование' }, { name: 'inn', value: 'ИНН' }, { name: 'kpp', value: 'KPP' }, { name: 'email', value: 'E-mail' }, { name: 'phone', value: 'Телефоны' }, { name: 'note', value: 'Примечание' }];

self.add = function () {
    return riot.route('/persons/companies/new');
};

self.companyOpen = function (e) {
    return riot.route('/persons/companies/' + e.item.row.id);
};

self.getContactCategory = function () {
    API.request({
        object: 'ContactCategory',
        method: 'Fetch',
        success: function success(response) {
            self.categories = response.items;
            self.update();
        }
    });
};

self.one('updated', function () {
    self.tags.catalog.on('reload', function () {
        self.getContactCategory();
    });
});

observable.on('companies-reload', function () {
    return self.tags.catalog.reload();
});

self.getContactCategory();
});


// WEBPACK FOOTER //
// ./pages/persons/companies-list.tag